export default __webpack_public_path__ + "static/haven_burkee-fce352b83d7614ccc2676d3c4e812dc3.jpg";